import React from "react";
import styled, {keyframes} from "styled-components";
import {ReactComponent as DownArrow} from "../../assets/downArrow.svg";
import {device} from "../../styles/breakpoints";

const StyledWrapper = styled.div`
  height: 90vh;
  margin: 20vh 5vw 10vh 5vw;
  display: flex;
  flex-direction: column;
  align-items: center;

`;


const StyledParagraph = styled.p`
  text-align: center;
`;
const Heading1 = styled.h1`
  color: #7879F1;
  font-size: 40px;
  text-align: center;
  margin-top: 0;
  @media ${device.tablet} {
    font-size: 60px;
  }
`;

const StyledButton = styled.button`
  padding: 15px 40px;
  background: none;
  border: 3px solid #7879F1;
  border-radius: 30px;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
`;
const ArrowAnimation = keyframes`
  from {
    transform: translateY(-50px);
  }
  to {
    transform: translateY(0);
  }
`;
const StyledDownArrow = styled(DownArrow)`
  margin-top: 100px;
  animation: ${ArrowAnimation} 2s linear infinite;
`;


const Welcome = () => {
  return (
    <>
      <StyledWrapper>
        <StyledParagraph small>Let Ai help your</StyledParagraph>
        <Heading1>MARKETING TEAM</Heading1>
        <StyledParagraph>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas purus odio tempor rutrum
          condimentum
          viverra
          ornare. Gravida tellus ut venenatis.</StyledParagraph>
        <StyledButton>Let's go </StyledButton>
        <StyledDownArrow/>
      </StyledWrapper>
    </>
  )
};
export default Welcome;
